import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ContactsShell from "../contacts/ContactsShell";
import { api } from "../../../lib/apiClient";

export default function AgencyContactsPage() {
  const { agencyId } = useParams();
  const [agency, setAgency] = useState(null);
  useEffect(() => {
    api.get(`/api/admin/agencies/${agencyId}`).then(setAgency).catch(() => setAgency(null));
  }, [agencyId]);
  return (
    <ContactsShell
      scope="agency"
      agencyId={agencyId}
      scopeLabel={agency ? `${agency.name} · ${agency.tier} · ${agency.contact_count} contacts · ${agency.user_count} users` : `Agency ${agencyId}`}
      scopeHref={`/admin/agencies/${agencyId}`}
    />
  );
}
